import { Link } from "react-router-dom";

export function LegalConsent({ checked, onChange, testId }: { checked: boolean; onChange: (v: boolean) => void; testId: string }) {
  const link = "font-semibold text-[#1B2A4A] underline";
  return (
    <label className="flex items-start gap-2 text-sm text-slate-600">
      <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} className="mt-0.5 h-4 w-4 shrink-0 accent-[#1B2A4A]" data-testid={testId} />
      <span>
        Acepto los <Link to="/terminos" target="_blank" className={link} data-testid={`${testId}-terms-link`}>Términos y Condiciones</Link> y
        el <Link to="/privacidad" target="_blank" className={link} data-testid={`${testId}-privacy-link`}>Aviso de Privacidad</Link>, y doy mi consentimiento
        expreso para que se traten mis datos financieros y patrimoniales para prestarme el servicio.
      </span>
    </label>
  );
}

export function PrivacyNotice() {
  return (
    <p className="mt-6 text-xs leading-relaxed text-slate-500" data-testid="register-privacy-notice">
      Alejandro Girón, con domicilio en Blvd Botánica, usa tu nombre, tu correo y la información financiera que registres para darte el servicio de
      Otium, cobrar tu suscripción y responder tus preguntas en el mentor, el cual usa inteligencia artificial de un proveedor en Estados Unidos.
      También podemos usar tu correo para enviarte información de otros productos; si no lo quieres, escríbenos
      a <a href="mailto:hola@alejandrogiron.com" className="underline">hola@alejandrogiron.com</a>. Consulta el aviso completo
      en <Link to="/privacidad" target="_blank" className="underline" data-testid="register-privacy-notice-link">{`${new URL(process.env.REACT_APP_BACKEND_URL as string).host}/privacidad`}</Link>.
    </p>
  );
}
